import { FixedPageHeader } from 'Components/Layout';
import { WorksheetBalanceConfigurationDialogButton } from 'Components/WorksheetGrids/Core/WorksheetBalanceConfiguraiton';
import { useSelector } from 'react-redux';

interface IFixedWorksheetGridHeaderProps {
  pageIdentifier: string;
}

const FixedWorksheetGridHeader: React.FC<IFixedWorksheetGridHeaderProps> = ({ pageIdentifier }) => {
  const saving = useSelector((state) =>
    Object.values(state.worksheetGrid.worksheets).some((w) => w.status.synchronising)
  );
  const dirty = useSelector((state) => Object.values(state.worksheetGrid.worksheets).some((w) => w.status.dirty));
  const worksheetsLoaded = useSelector(
    (state) => state.worksheetGrid.worksheets && Object.values(state.worksheetGrid.worksheets).length > 0
  );

  return (
    <FixedPageHeader
      pageIdentifier={pageIdentifier}
      pageStatus={saving ? 'Saving...' : worksheetsLoaded ? 'Saved' : ''}
      pageProcessing={saving || dirty}
      pageAdditionalAction={<WorksheetBalanceConfigurationDialogButton />}
    />
  );
};

export default FixedWorksheetGridHeader;
